import type { Users } from 'modules/core/store/collections/users'
import type User from 'modules/core/store/models/User'

import hasRegularAccess from 'modules/employees/lib/hasRegularAccess'
import type { Employees } from 'modules/employees/store/collections/employees'

export function usersWithRegularAccess(users: Users, employees: Employees): User[] {
  return users.models.filter((user) => {
    const employee = user.isNew
      ? undefined
      : employees.find({
          access_id: user.attributes.id,
        })
    if (!user.isActive(employee)) return false
    if (!employee) return true
    return hasRegularAccess(employee.attributes.has_regular_access)
  })
}
